import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  ExDropdownV2Component,
  ExDropdownV2ContentDirective,
  ExDropdownV2HeaderDirective,
} from '../../../../common-explain/components/ex-dropdown-v2/ex-dropdown-v2.component';

/** Contextual (kebab) menu of a document line: view / download / delete. */
@Component({
  selector: 'app-document-row-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ExDropdownV2Component, ExDropdownV2HeaderDirective, ExDropdownV2ContentDirective],
  templateUrl: './document-row-menu.component.html',
  styleUrls: ['./document-row-menu.component.scss'],
})
export class DocumentRowMenuComponent {
  @Input() showView = true;
  @Input() showDownload = true;
  @Input() showDelete = true;

  readonly view = output<void>();
  readonly download = output<void>();
  readonly delete = output<void>();

  onView(close: () => void): void {
    this.view.emit();
    close();
  }

  onDownload(close: () => void): void {
    this.download.emit();
    close();
  }

  onDelete(close: () => void): void {
    this.delete.emit();
    close();
  }
}
